const capitalize = (stringToCapitalize) => {
    const trimmedString = stringToCapitalize.trim();

    return trimmedString.charAt(0).toUpperCase() + trimmedString.slice(1);
};

export default capitalize;
